export const ROLES = {
  SUPER_ADMIN: "superAdmin",
  ACCOUNTANT: "accountant",
  ADMIN: "admin",
  STAFF: "staff",
};

export const ALL_ADMIN_ROLES = Object.values(ROLES);

export const PERMISSIONS = {
  DASHBOARD: [ROLES.SUPER_ADMIN],
  EMPLOYEE_MANAGE: [ROLES.SUPER_ADMIN],
  USER_ADD: [ROLES.SUPER_ADMIN],
  MASTER_DATA_MANAGE: [ROLES.SUPER_ADMIN, ROLES.ACCOUNTANT, ROLES.ADMIN],
  PRODUCT_SECTION_MANAGE: [ROLES.SUPER_ADMIN],
  BANNER_MANAGE: [ROLES.SUPER_ADMIN],
  FINANCE: [ROLES.SUPER_ADMIN, ROLES.ACCOUNTANT, ROLES.ADMIN],
  OPERATIONS: [ROLES.SUPER_ADMIN, ROLES.ACCOUNTANT, ROLES.ADMIN],
  SERVER_REPORT: [
    ROLES.SUPER_ADMIN,
    ROLES.ACCOUNTANT,
    ROLES.ADMIN,
    ROLES.STAFF,
  ],
  WIFI_BOOST: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.STAFF],
  WIFI_OPTIONS: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  USER_CREATION: [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.ACCOUNTANT,
    ROLES.STAFF,
  ],
  PRODUCT_RECEIPTS: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  DELIVERY_NOTES: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  SERVICE_CALL_REPORTS: [
    ROLES.SUPER_ADMIN,
    ROLES.ACCOUNTANT,
    ROLES.ADMIN,
    ROLES.STAFF,
  ],
  SYSTEM_RECORDS: [ROLES.SUPER_ADMIN, ROLES.ACCOUNTANT, ROLES.ADMIN],
  ADMIN_HOME: ALL_ADMIN_ROLES,
};

export const hasRoleAccess = (role, allowedRoles = []) =>
  Boolean(role) && allowedRoles.includes(role);
